import { render, staticRenderFns } from "./xitongshuju-detail.vue?vue&type=template&id=d654e942&"
import script from "./xitongshuju-detail.vue?vue&type=script&lang=ts&"
export * from "./xitongshuju-detail.vue?vue&type=script&lang=ts&"
import style0 from "./xitongshuju-detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports